import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { StorageService } from 'services';
import { Language } from 'common/types';

// Import translations directly
import en from '../translations/en.json';
import de from '../translations/de.json';
import fr from '../translations/fr.json';
import it from '../translations/it.json';

const DEFAULT_APP_LANGUAGE = Language.ENGLISH;
const supportedLngs = Object.entries(Language).map(([, value]) => value);
const usersLanguage = StorageService.getItem('language');

const resources = {
  en: { translation: en },
  de: { translation: de },
  fr: { translation: fr },
  it: { translation: it },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: usersLanguage || DEFAULT_APP_LANGUAGE,
    resources,
    interpolation: {
      escapeValue: false,
    },
    supportedLngs,
    detection: { lookupLocalStorage: 'language', order: ['localStorage'] },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
